/**
 * Base notification context enum
 * @description Common notification contexts that apply to all subjects
 */
export enum BaseNotificationContextEnum {
	INSERTED = 'inserted',
	UPDATED = 'updated',
	DELETED = 'deleted',
}
